/*
 * @desc 统一管理所有的定值
 */

let constants = {}

constants.basic = {
  version: '1.0',
  apiBaseUrl: '',
  siteName: '赛为道路交通安全培训后台管理系统',
  shortSiteName: '赛为安全',
  companyName: '赛为安科技',
  domain: process.env.DOMAIN + '/api.php',
  domain_pic: process.env.DOMAIN + '/storage/',
}

export default constants



// WEBPACK FOOTER //
// ./src/config/constants.js